
// Removed import socket from '../socket';

export function getBotConfig(socket: any, id: string) { // Added socket parameter
  socket.send('getBotConfig', { id });
}

export function patchBotConfig(socket: any, id: string, fields: any, password: string) { // Added socket parameter
  return new Promise((resolve, reject) => {
    const cleanup = () => {
      socket.off('botConfigUpdated', handleSuccess);
      socket.off('botConfigError', handleError);
      clearTimeout(timeout);
    };

    const handleSuccess = (payload: any) => {
      if (payload?.id && payload.id !== id) return;
      cleanup();
      resolve(payload);
    };

    const handleError = (payload: any) => {
      if (payload?.id && payload.id !== id) return;
      cleanup();
      reject(new Error(payload?.error || 'Failed to update bot configuration'));
    };

    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error('Timed out while saving bot configuration'));
    }, 15000);

    socket.on('botConfigUpdated', handleSuccess);
    socket.on('botConfigError', handleError);
    socket.send('patchBotConfig', { id, data: { ...fields, password } });
  });
}

export async function fetchBotConfigRest(botId: string) {
  const response = await fetch(`/api/bot-config/${botId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch bot config: ${response.statusText}`);
  }
  return response.json();
}
